export default {"src":"/_next/static/media/leadboard-logo.56b1a366.svg","height":194,"width":1250,"blurWidth":0,"blurHeight":0};